// src/pages/DeniedPage.tsx — themed access-denied page.
// Reached two ways: (1) the OIDC callback redirected here because the
// account authenticated at the forum but isn't authorized for the admin
// (no session exists), or (2) an active session's group lost all
// permissions mid-session (/api/me returns 403).
import { Sigil } from '../components/Sigil';

export function DeniedPage({ hasSession = false }: { hasSession?: boolean }) {
  return (
    <div className="min-h-screen flex flex-col bg-bg text-ink">
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md text-center">
          <div className="flex justify-center mb-6 opacity-60">
            <Sigil size={72} />
          </div>
          <div className="font-mono text-[10px] tracking-eyebrow uppercase text-err-soft mb-2">
            ◆ Access Denied
          </div>
          <h1 className="font-display font-bold text-[26px] tracking-[0.04em] uppercase text-ink mb-4">
            Not Authorized
          </h1>
          <p className="text-sm text-ink-2 leading-relaxed mb-8">
            Your EOTIR Nexus account was verified, but it does not hold a staff
            role with access to the OIDC Bridge admin. If you believe this is an
            error, contact a bridge administrator.
          </p>
          {hasSession ? (
            <a href="/api/auth/logout" className="eo-btn eo-btn--ghost inline-block">
              Sign out
            </a>
          ) : (
            <a href="/" className="eo-btn eo-btn--ghost inline-block">
              Back
            </a>
          )}
          <p className="font-mono text-[10.5px] tracking-label uppercase text-ink-4 mt-8">
            This access attempt has been logged.
          </p>
        </div>
      </main>
      <footer className="border-t border-line bg-bg-1 px-7 py-2.5 font-mono text-[10px] tracking-label uppercase text-ink-4 text-center">
        EOTIR · OIDC Bridge · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
